module.exports = __webpack_public_path__ + "img/app-bilibili.3903d914.png";